
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/lookalike-audiences",
      function () {
        return require("private-next-pages/customer-studio/lookalike-audiences.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/lookalike-audiences"])
      });
    }
  